import React,{createContext} from 'react';

const StorageContext = createContext({});

export default StorageContext